import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';

import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import Swal from 'sweetalert2';
export interface DialogData
{
    idPostulacion: any,
    tiposRechazo: [],
    tipoRechazo: any,
    email: any,
    nombreCompleto: any,
    nombreProducto: any,
    comentarioRechazo: any
};

@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/common/postulacion-rechazar.html',
    styleUrls: ['../../pages/common/postulacion-rechazar.css'],
})
export class DialogTipoRechazo
{
    constructor( public dialogRef: MatDialogRef<DialogTipoRechazo>,
                 private postulacionesService: PostulacionesService,
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog, )
                 { }

    onRechazarClick()
    {
      Swal.fire({
        allowOutsideClick:false,
        icon:'info',
        text:'Cargando...'
      });
      let idUsuarioSesion = localStorage.getItem("idUsuario")
      Swal.showLoading();
      let vm = this     
      let idMotivoRechazo = this.data.tipoRechazo.split('-')[0]
      let motivoRechazo = this.data.tipoRechazo.split('-')[1]

      this.postulacionesService.rechazarPostulacion(this.data.idPostulacion, idMotivoRechazo,
      motivoRechazo, this.data.comentarioRechazo,idUsuarioSesion).then
        (
            () =>
            {
              Swal.close();
                vm.dialogRef.close()
                vm.openAlertDialog('La postulación se ha rechazado exitosamente.', 'btn-success')
            }
        )
        .catch
        (
            error =>
            {
              Swal.close();
                console.log(error)
                vm.dialogRef.close()
                vm.openAlertDialog('La postulación no se ha podido rechazar.', 'btn-danger')
            }
        );
    }

    onCancelarClick(): void { this.dialogRef.close() }

    openAlertDialog(mensaje: string, clase: string)
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}
